/* Memorial ornament renderer. Shared by the product page preview and HQ's print-file service.
   drawOrnament(ctx, {side, shape, name, years, line}, scale)
     side   'front' (IN MEMORY OF / NAME / years) or 'back' (the line about them)
     shape  'circle' (886x886 print area) or 'heart' (945x886)
   Fonts required: "BIW Lit Title" (name), "Arimo" (years, line), "Arimo Bold" (IN MEMORY OF). */
(function (root) {
  var NAME_FONT = '"BIW Lit Title"', BODY_FONT = 'Arimo', BOLD_FONT = '"Arimo Bold"';
  var INK = '#111111';
  var SHAPES = {
    circle: { W: 886, H: 886, CX: 443, CY: 468, NAME_W: 470, LINE_W: 470, RING: 0, K: 1.3 },
    heart: { W: 945, H: 886, CX: 472, CY: 400, NAME_W: 480, LINE_W: 470, RING: 0, K: 1.3 }
  };

  function clean(s, max) {
    return String(s || '').replace(/'/g, '’').replace(/\s+/g, ' ').trim().slice(0, max);
  }
  function sentence(s) {
    if (!s) return s;
    s = s.charAt(0).toUpperCase() + s.slice(1);
    if (!/[.!?…]$/.test(s)) s += '.';
    return s;
  }
  function spaced(ctx, text, cx, y, sp) {
    var w = ctx.measureText(text).width + sp * Math.max(0, text.length - 1), x = cx - w / 2;
    ctx.textAlign = 'left';
    for (var i = 0; i < text.length; i++) { ctx.fillText(text[i], x, y); x += ctx.measureText(text[i]).width + sp; }
  }
  function wrap(ctx, text, maxW) {
    var words = text.split(' '), lines = [], cur = '';
    for (var i = 0; i < words.length; i++) {
      var t = cur ? cur + ' ' + words[i] : words[i];
      if (ctx.measureText(t).width > maxW && cur) { lines.push(cur); cur = words[i]; } else cur = t;
    }
    if (cur) lines.push(cur);
    return lines;
  }
  // The same number of lines as a greedy wrap, but as even as they can be (no lonely last word).
  function balanced(ctx, text, maxW) {
    var n = wrap(ctx, text, maxW).length, lo = 0, hi = maxW;
    if (n < 2) return wrap(ctx, text, maxW);
    for (var k = 0; k < 20; k++) { var mid = (lo + hi) / 2; if (wrap(ctx, text, mid).length > n) lo = mid; else hi = mid; }
    return wrap(ctx, text, hi);
  }
  function nameLayout(ctx, name, maxW) {
    var s;
    for (s = 130; s >= 70; s -= 2) { ctx.font = s + 'px ' + NAME_FONT; if (ctx.measureText(name).width <= maxW) return { size: s, lines: [name] }; }
    var words = name.split(' ');
    if (words.length > 1) {
      var best = null;
      for (var i = 1; i < words.length; i++) {
        var a = words.slice(0, i).join(' '), b = words.slice(i).join(' ');
        ctx.font = '80px ' + NAME_FONT;
        var m = Math.max(ctx.measureText(a).width, ctx.measureText(b).width);
        if (!best || m < best.m) best = { m: m, lines: [a, b] };
      }
      for (s = 100; s >= 44; s -= 2) {
        ctx.font = s + 'px ' + NAME_FONT;
        if (ctx.measureText(best.lines[0]).width <= maxW && ctx.measureText(best.lines[1]).width <= maxW) return { size: s, lines: best.lines };
      }
      return { size: 44, lines: best.lines };
    }
    for (s = 70; s > 20; s -= 2) { ctx.font = s + 'px ' + NAME_FONT; if (ctx.measureText(name).width <= maxW) break; }
    return { size: s, lines: [name] };
  }

  function drawOrnament(ctx, data, scale) {
    var g = SHAPES[data.shape === 'heart' ? 'heart' : 'circle'];
    ctx.save();
    ctx.setTransform(scale || 1, 0, 0, scale || 1, 0, 0);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, g.W, g.H);
    ctx.fillStyle = INK;
    ctx.strokeStyle = INK;
    ctx.textBaseline = 'alphabetic';
    if (g.RING) {
      ctx.lineWidth = 4;
      ctx.beginPath(); ctx.arc(g.CX, g.CY, g.RING, 0, Math.PI * 2); ctx.stroke();
    }
    // Everything inside is drawn at K times, about the centre, to fill the shape.
    ctx.translate(g.CX, g.CY); ctx.scale(g.K, g.K); ctx.translate(-g.CX, -g.CY);
    if (data.side === 'back') {
      var line = sentence(clean(data.line, 60));
      ctx.textAlign = 'center';
      if (line) {
        ctx.font = '50px ' + BODY_FONT;
        var ll = balanced(ctx, line, g.LINE_W).slice(0, 4), lh = 66;
        var y0 = g.CY - ((ll.length - 1) * lh) / 2 + 18;
        for (var j = 0; j < ll.length; j++) ctx.fillText(ll[j], g.CX, y0 + j * lh);
      }
      ctx.restore();
      return;
    }
    var name = clean(data.name, 24).toUpperCase();
    var years = clean(data.years, 15);
    var nl = name ? nameLayout(ctx, name, g.NAME_W) : null;
    var topH = 26, gap1 = 46, nameH = nl ? nl.size * 0.8 + (nl.lines.length - 1) * nl.size : 0, gap2 = years ? 44 : 0, yearsH = years ? 24 : 0;
    var total = topH + (nl ? gap1 + nameH : 0) + gap2 + yearsH;
    var y = g.CY - total / 2;
    ctx.font = '30px ' + BOLD_FONT;
    spaced(ctx, 'IN MEMORY OF', g.CX, y + topH, 9);
    y += topH;
    if (nl) {
      y += gap1;
      ctx.textAlign = 'center';
      ctx.font = nl.size + 'px ' + NAME_FONT;
      for (var i = 0; i < nl.lines.length; i++) ctx.fillText(nl.lines[i], g.CX, y + nl.size * 0.8 + i * nl.size);
      y += nameH;
    }
    if (years) {
      y += gap2;
      ctx.font = '32px ' + BODY_FONT;
      spaced(ctx, years, g.CX, y + yearsH, 4);
    }
    ctx.restore();
  }

  root.drawOrnament = drawOrnament;
  root.ornamentShapes = SHAPES;
  root.ornamentSentence = sentence;
  if (typeof module !== 'undefined' && module.exports) module.exports = { drawOrnament: drawOrnament, SHAPES: SHAPES, sentence: sentence };
})(typeof window !== 'undefined' ? window : globalThis);
